import { Tab as ChakraTab } from '@chakra-ui/react'

export const Tab = ({ children, ...rest }) => {
  return (
    <ChakraTab
      bgColor={'primary.50'}
      border={'1px solid'}
      borderColor={'primary.100'}
      borderRadius={6}
      _selected={{ bgColor: 'primary.500', color: 'white' }}
      _hover={{ boxShadow: 'inner' }}
      {...rest}
    >
      {children}
    </ChakraTab>
  )
}
